import { Inject } from '@angular/core';
import { InjectionToken } from '@angular/core';
import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { ofType } from '@ngrx/effects';
import { createEffect } from '@ngrx/effects';
import { toErrorMessage } from 'app/modules/main/helper/error-mapper';
import { PublisherTimeZoneService } from 'app/modules/main/services/publisher-time-zone.service';
import { PublisherTimeZoneActions } from 'app/modules/main/store/publisher-time-zone/publisher-time-zone.actions';
import { LoadPublisherTimeZoneAction } from 'app/modules/main/store/publisher-time-zone/publisher-time-zone.actions';
import { UserAuthorizationActions } from 'app/modules/main/store/user-authorization/user-authorization.actions';
import { UserAuthorizationSelectors } from 'app/modules/main/store/user-authorization/user-authorization.selectors';
import { EMPTY } from 'rxjs';
import { of } from 'rxjs';
import { first } from 'rxjs/operators';
import { exhaustMap } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PublisherTimeZoneEffects {

  static readonly LOAD =
    new InjectionToken<LoadPublisherTimeZoneAction[]>('LOAD');

  constructor(
    private readonly actions: Actions,
    private readonly publisherTimeZoneService: PublisherTimeZoneService,
    private readonly userAuthorizationSelectors: UserAuthorizationSelectors,
    @Inject(PublisherTimeZoneEffects.LOAD)
    private readonly loadTimeZoneActions: LoadPublisherTimeZoneAction[],
  ) {
  }

  readonly load = createEffect(
    () => this.actions.pipe(
      ofType(...this.loadTimeZoneActions.flat()),
      exhaustMap(() => this.fetchPublisherTimeZone()),
    )
  );

  private fetchPublisherTimeZone() {

    return this.userAuthorizationSelectors.getOnePublisherId()
      .pipe(
        switchMap(publisherId => this.publisherTimeZoneService.fetch(publisherId)),
        first(),
        map(PublisherTimeZoneActions.$.publisherTimeZoneLoaded),
        catchError((error: any) =>
          error.status !== 0
            ? of(PublisherTimeZoneActions.$.publisherTimeZoneLoadFailed(toErrorMessage(error)))
            : EMPTY
        ),
      );
  }

}
